<template>
  <v-app-bar app class="custom-bar">
    <v-spacer></v-spacer>

    <!-- Desktop navigation -->
    <div class="nav-links d-none d-md-flex align-center">
      <router-link to="/" class="title-link">
        <v-icon style="font-size: 28px; margin-bottom: 2px">mdi-home</v-icon>
      </router-link>
      <!-- <span class="separator">/</span>
      <router-link to="/about" class="title-link">
        <span>About</span>
      </router-link> -->
      <!-- <span class="separator">/</span> -->
      <!-- <router-link to="/projects" class="title-link">
        <span>Projects</span>
      </router-link> -->
      <span class="separator">/</span>
      <router-link to="/resume" class="title-link">
        <span>CV</span>
      </router-link>
    </div>

    <!-- Mobile hamburger button -->
    <v-app-bar-nav-icon
      class="d-md-none"
      @click="drawer = !drawer"
    ></v-app-bar-nav-icon>
  </v-app-bar>

  <!-- Mobile navigation drawer -->
  <v-navigation-drawer
    v-model="drawer"
    temporary
    location="right"
    class="d-md-none"
  >
    <v-list nav>
      <v-list-item
        v-for="item in navItems"
        :key="item.title"
        :to="item.to"
        @click="drawer = false"
      >
        <template v-slot:prepend>
          <v-icon>{{ item.icon }}</v-icon>
        </template>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      navItems: [
        { title: "Home", to: "/", icon: "mdi-home" },
        // { title: "About", to: "/about", icon: "mdi-account" },
        // { title: "Projects", to: "/projects", icon: "mdi-folder-open" },
        { title: "CV", to: "/resume", icon: "mdi-file-document" },
      ],
    };
  },
};
</script>

<style>
.custom-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
}
.nav-links {
  margin-right: 2%;
}
.title-link {
  text-decoration: none;
  color: lightskyblue;
  font-size: 22px;
  font-weight: bold;
  transition: transform 0.2s ease, color 0.2s ease;
}
.title-link:hover {
  transform: scale(1.1);
  color: #f09228;
}
.separator {
  text-decoration: none;
  color: lightskyblue;
  font-size: 22px;
  margin: 0 10px;
  font-weight: bold;
}
</style>